export const path = {
  crew: {
    Notifications: {
      root: "/crew_portal/notifications",
      detail: (id: number) => `/crew_portal/notifications/${id}`,
    },
  },
  driver: {
    Notifications: {
      root: "/driver_portal/notifications",
      detail: (id: number) => `/driver_portal/notifications/${id}`,
    },
  },
};
